import qs from 'qs';
import { getEventId, getCsrfToken, safeJsonParse } from './utils';

/**
 * Filters out and formats success response.
 * @param {object} response
 * @return {object}
 */
function formatSuccessResponse(response) {
    return {
        url: response.filename,
        ext: response.ext,
    };
}

/**
 * Implementation with XMLHttpRequest because of Cake's back-end, fileupload.php
 * @param  {File} file resource.
 * @return {Promise} resolves with an object containing the key `url` of the image uploaded.
 */
export default function (file) {
    return new Promise((resolve, reject) => {
        const url = `/events/fileUpload/${getEventId() || ''}`;
        const queryString = qs.stringify({
            qqfile: file.name,
        });

        const xhr = new XMLHttpRequest();
        xhr.open('POST', `${url}?${queryString}`, true);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.setRequestHeader('X-File-Name', encodeURIComponent(file.name));
        xhr.setRequestHeader('X-UserFormSubmitToken', getCsrfToken());
        xhr.setRequestHeader('Content-Type', 'application/octet-stream');
        xhr.setRequestHeader('Accept', 'application/json');

        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                const response = safeJsonParse(xhr.response);
                if (!response) {
                    reject({ error: 'jsonParseError' });
                } else if (response.error) {
                    reject(response);
                } else {
                    resolve(formatSuccessResponse(response));
                }
            } else {
                reject({
                    error: 'badHttpStatus',
                    status: this.status,
                    // if response has an error, we use that instead. eg: sizeLimitReached.
                    ...(safeJsonParse(xhr.response) || {}),
                });
            }
        };
        xhr.onerror = function () {
            reject({
                error: 'badHttpStatus',
                status: this.status,
            });
        };

        xhr.send(file);
    });
}
